import { Box, CircularProgress } from '@mui/material'
import JobFitCard from './JobFitCard'
import JobFitEmptyCard from './JobFitEmptyCard'

const JobFitDrawer = ({ data, error, isLoading }) => {
  if (isLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        sx={{
          width: '100%',
          height: 200,
        }}
      >
        <CircularProgress color="alternate" />
      </Box>
    )
  } else if (error !== null || data === null || data.length === 0) {
    return (
      <Box mb={4}>
        <JobFitEmptyCard />
      </Box>
    )
  } else {
    return (
      <Box mb={4}>
        <JobFitCard data={data} />
      </Box>
    )
  }
}
export default JobFitDrawer
